import { request } from "/src/utils/index.js";
import { request2 } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request2.get("sys/role/list", { params });
}

export function Detail(params) {
  // console.log(parmas);
  return request.get("sys/role" + params);
}

export function Add(params) {
  return request.post("sys/role", params);
}

export function Update(params) {
  return request.put("sys/role", params);
}

export function Delete(data) {
  return request.delete("sys/role", { data });
}
